export const MgmOffResources = {
    title: "Polecaj i <b>zarabiaj</b>",
    description: "Przykro nam, ale nie możesz dokonywać poleceń.",
    mgmActiveDescription:
        "Zaloguj się, aby sprawdzić czy możesz wziąć udział w programie Polecaj i zarabiaj!",

    recommendAndEarn: {
        title: "<b>Oszczędzasz</b><br>dalej?",
        info: "Możesz dalej cashbackować, robiąc zakupy z goodie.",
        btnText: "Zaczynam zakupy!",
    },
};
